module.exports = __webpack_public_path__ + "img/picture11.c3096fc2.png";